import { Factory } from '../Factory';
import { Service } from '../Service';

export class ReportService extends Service<any> {
  private configService: any;
  private tokenService: any;

  constructor(resource: any, rootScope: IRootScope, configService: any, resourceWrapperService, tokenService: any, notificationService: any) {
    super({resource, rootScope, resourceWrapperService});

    this.configService = configService;
    this.tokenService = tokenService;

    let raw = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/report/:id`,
      {id: "@id", projectId: "@projectId"},
      {
        update: {method: "PUT"},
        query: {method: "GET", params: {page: 1, limit: 50}, isArray: false}
      });

    this.itemResource = this.resourceWrapperService.WrapActions(raw);

    this.rootScope.$on("FeedService.ReportComplete", (event, message) => {
      notificationService.addSuccess({
        title: "Report available",
        description: `Report: ${message.name} has completed.`,
        buttons: `<a class="btn btn-success" iio-audit="{projectId: '${message.projectId}', description: 'Download Report', actionDetails: {reportName: '${message.name}', uri: '${message.directDownloadPath.split('?')[0]}'}}" href="${message.directDownloadPath}"><i class="icon-download-alt"></i> Download</a>`
      });
    });

    this.rootScope.$on("FeedService.ReportUpdate", (event, message) => {
      this.FindOne({id: message.id, projectId: message.projectId}).then((report: any) => {
        report.status = message.status;
        report.bytes = message.bytes;
        report.path = message.path;
        report.directDownloadPath = message.directDownloadPath;
      });
    });
  }

  public Find(projectId, page, limit, filter, callback) {
    return this.itemResource.query({
      projectId: projectId,
      page: page,
      limit: limit,
      filter: filter
    }, (reportsPage) => {
      // Fill up our on-page cache
      this.items.length = 0;
      angular.forEach(reportsPage.reports, (report) => {
        this.items.push(report);
      });

      if (callback) callback(reportsPage);
    });
  }
}

frontendApp.factory("ReportService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", "TokenService", "NotificationService", Factory.Create(ReportService)]);
